<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-document"></i> 护士站列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-button
          type="primary"
          icon="el-icon-delete"
          class="handle-del mr10"
          @click="handleAdd"
        >新增</el-button>
        <!-- <el-input v-model="query.name" placeholder="用户名" class="handle-input mr10"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button> -->
      </div>
      <el-table :data="tableData" border stripe class="table" header-cell-class-name="table-header">
        <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
        <el-table-column prop="name" label="护士站名称"></el-table-column>
        <el-table-column prop="mobile" label="电话"></el-table-column>
        <!--<el-table-column label="绑定宝贝数量">-->
          <!--<template slot-scope="scope">-->
            <!--{{ }}-->
          <!--</template>-->
        <!--</el-table-column>-->
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="Nurse.pageIndex"
          :page-size="Nurse.limit"
          :total="Nurse.total"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 新增护士弹出框 -->
    <el-dialog title="新建护士站" :visible.sync="addVisible" width="30%">
      <el-form ref="addForm" :model="addForm" label-width="70px">
        <el-form-item label="名称">
          <el-input v-model="addForm.name" maxlength="18"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="addForm.mobile" maxlength="11"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["Nurse"])
  },
  data() {
    return {
      authVisible: false,
      addVisible: false,
      addForm: {},
      authForm: {},
      query: {
        address: "",
        name: "",
        pageIndex: 1,
        limit: 10
      },
      tableData: [],
      multipleSelection: [],
      delList: [],
      idx: -1,
      id: -1
    };
  },
  watch: {
    "Nurse.list"(val) {
      console.log(val)
      this.tableData = val;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const Nurse = this.Nurse;
      this.$api.getNurseList({
        offset: Nurse.offset || 0,
        limit: Nurse.limit
      });
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    // 删除操作
    handleDelete(index, row) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning"
      })
        .then(() => {
          this.$message.success("删除成功");
          this.tableData.splice(index, 1);
        })
        .catch(() => {});
    },
    // 添加员工
    handleAdd() {
      this.addVisible = true;
    },
    // 保存编辑
    async saveAdd() {
      this.addVisible = false;
      const addForm = this.addForm;
      let res = await this.$api.createNurse(addForm);
      const data = res.data
      if (data.ok) {
        this.getData()
        this.$message.success(`【${addForm.name}】护士站开通成功`);
      }
    },
    // 编辑操作
    handleEdit(row) {
      sessionStorage.setItem('nurse_' + row._id, JSON.stringify(row))
      this.$router.push({
        path: "/nurse/" + row.id
      });
    },
    // 分页导航
    handlePageChange() {
      this.getData();
    }
  }
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Nurse.vue